import { Box, Container, HStack, Modal, ModalBody, ModalContent, ModalOverlay, Stack, useBreakpointValue} from "@chakra-ui/react";
import React from "react";
import "react-vertical-timeline-component/style.min.css";
import { explore } from "../../../constants/constants";
import { CopyPasteService } from "../../../services/CopyPaste";
import InfiniteScroll from "react-infinite-scroll-component";
// import { FilterBox } from "../../../../CommonComponents/Filter/FilterBox";
// import { FilterButton } from "../../../../CommonComponents/Filter/FilterButton";
import NoMoreToLoad from "../../NoMoreToLoad";
import { FilterBox } from "../../../CommonComponents/Filter/FilterBox";
import Grid from "../../SimpleGrid/Grid";
import ArchiveGrid from "../../SimpleGrid/ArchiveGrid";
// import { FilterButton } from "../../../CommonComponents/Filter/FilterButton";
import { DataNotFound } from "../../../CommonComponents/DataNotFound";
// import FilterPills from "../../../../CommonComponents/Filter/FilterPills";
// import ContentModal from "../../../../pages/Film/ResearchCentre/Library/ContentModal";
// import SliderModal from "../../../../pages/Film/ResearchCentre/Library/SliderModal";
// import { FilterButtonGeneric } from "../../../../CommonComponents/Filter/FilterButtonGeneric";

//S3 Bucket osw-dev-images
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

function GridView({
  handleBookClick,
  contentClicked,
  scanClicked,
  setleftFlag,
  setContentClicked,
  setScanClicked,
  openDrawer,
  setOpenDrawer,
  tableName,
  masterlist,
  imageTitle,
  masterlistType = "generic",
  setLibraryCount,
  //new data props
  fetchMoreData,
  data,
  drawerBook,
  handleClose,
  showFilterBox,
  handleFilterClick,
  hasMore,
  handleItemNavigation,
  setShowFilterBox,
  setApply,
  sort,
  handleCheckboxChange,
  handleSearch,
  filterOptions,
  filteroptionData,
  setFilterOptions,
  setSearchTerm,
  filterCount,
  searchTerm,
  handleReset,
  bookAlias,
  filerStyle,
  setFilterPills,
  filterPills,
  setSwiper,
  handleContentClicked,
  indexValue,
  bookData,
  filteredResultCount,
  handlePagination,
  pageIndex,
  setPageIndex,
  contentImage,
  scannedImage,
  enableCheckbox = true,
  handleItemCheckboxChange
}) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <>
      <Stack flexDirection={{base:"column",md:"row-reverse"}}>
        {/* {!showFilterBox && <FilterButton marginTop="40px" top={masterlistType === "film" ? "173px" : "123px"} masterlistType={masterlistType} onClick={handleFilterClick} />} */}
        {/* {!showFilterBox && masterlistType === "generic" && (
                      <FilterButtonGeneric
                        masterlistType={masterlistType}
                        onClick={handleFilterClick}
                        marginTop="-38px!important"
                      />
                    )} */}
        <Container
          maxW="auto"
          className="songs"
          px={{ base: "0px", md: "0px" }}
          py={{base:masterlistType === "generic" || masterlistType === "film" ? "0px" : "0",
            md: masterlistType === "generic" ? "30px" : masterlistType === "film" ? "25px" : "4"}}
          // pt={{base:"0px",md:masterlistType === "generic"? "40px":"8"}}
          position={"relative"}
        >
          <Stack flexDirection={{base:"column",md:"row"}} gap={4} justifyContent="flex-start">
            {data && data?.length > 0 ? (
              <Stack
                onCopy={(e) =>
                  CopyPasteService(e, `${window.location.href}/0/1`)
                }
                marginRight={{ base: "0px", md: "30px" }}
                alignItems={"flex-start"}
              >
                  <Box zIndex={9} bg="white" width={"100%"} position={"sticky"} top={{base:masterlistType === "film"
        ? "225px":"155px",md:masterlistType === "film"
        ? "300px":masterlistType === "generic"
        ? "162px":"125px"}}>
          {/* {((filterPills &&  filterPills?.search) || filterCount > 0) && 
          <FilterPills
          filters={filterPills}
          setFilterOptions={setFilterOptions}
          setApply={setApply}
          setSearchTerm={setSearchTerm}
          setFilterPills={setFilterPills}
          filteredResultCount={filteredResultCount}
          />
          } */}
          </Box>
                <InfiniteScroll
                  dataLength={data?.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  loader={
                   <Box textAlign="center" display={"flex"} justifyContent={"center"}>
                      <Stack marginTop={"20px"}>
                        <img
                          src={loaderImg}
                          width={"100px"}
                          height={"100px"}
                          alt="Loading"
                        />
                      </Stack>
                    </Box>
                  }
                  endMessage={<NoMoreToLoad />}
                >
                  <Grid
                    data={data}
                    handleDrawer={handleItemNavigation}
                    spacing={{base:"10px",md:"24px"}}
                    columns={{ base: 2, md: 3, lg: 4, xl: 4 }}
                    component={ArchiveGrid}
                    border={true}
                    enableCheckbox={true}
                    handleCheckboxChange={handleItemCheckboxChange}
                  />
                </InfiniteScroll>
              </Stack>
            ) 
            : (
              <>
                <Stack
                onCopy={(e) =>
                  CopyPasteService(e, `${window.location.href}/0/1`)
                }
                marginRight={{ base: "0px", md: "30px" }}
                alignItems={"flex-start"}
                width={"100%"}
              >
                  <Box zIndex={9} bg="white" width={"100%"} position={"sticky"} top={{base:masterlistType === "film"
                   ? "225px":"155px",md:masterlistType === "film" ? "245px":"125px"}}>
                      {/* {((filterPills &&  filterPills?.search) || filterCount > 0) && 
                      <FilterPills
                      filters={filterPills}
                      setFilterOptions={setFilterOptions}
                      setApply={setApply}
                      setSearchTerm={setSearchTerm}
                      setFilterPills={setFilterPills}
                      filteredResultCount={filteredResultCount}
                      />
                      } */}
                   </Box>
                <HStack width={"100%"} justifyContent={"center"}>
                  <DataNotFound />
                </HStack>
                </Stack>
              </>
            )}
            <HStack
              marginLeft={"4"}
              marginRight={"0px!important"}
              className="mt-0"
              alignItems={"flex-start"}
              pos={masterlistType === "generic" && "relative"}
              right={masterlistType === "generic" && "-5px"}
            >
               {showFilterBox && (
                    isMobile ? (
                      <Modal isOpen={showFilterBox} onClose={() => setShowFilterBox(false)} returnFocusOnClose={false}>
                        <ModalOverlay bg="rgba(0, 0, 0, 0.8)"/>
                        <ModalContent>
                          <ModalBody px="15px">
                            <pFilterBox
                               setShowFilterBox={setShowFilterBox}
                               setApply={setApply}
                               explore={explore}
                               sort={sort}
                               handleCheckboxChange={handleCheckboxChange}
                               handleSearch={handleSearch}
                               filterOptions={filterOptions}
                               filteroptionData={filteroptionData}
                               setFilterOptions={setFilterOptions}
                               setSearchTerm={setSearchTerm}
                               filterCount={filterCount}
                               searchTerm={searchTerm}
                               handleReset={handleReset}
                               className={filerStyle? filerStyle : "box-filter-film"}
                              />
                          </ModalBody>
                        </ModalContent>
                      </Modal>
                    ) : (
                      <FilterBox
                      setShowFilterBox={setShowFilterBox}
                      setApply={setApply}
                      explore={explore}
                      sort={sort}
                      handleCheckboxChange={handleCheckboxChange}
                      handleSearch={handleSearch}
                      filterOptions={filterOptions}
                      filteroptionData={filteroptionData}
                      setFilterOptions={setFilterOptions}
                      setSearchTerm={setSearchTerm}
                      filterCount={filterCount}
                      searchTerm={searchTerm}
                      handleReset={handleReset}
                      className={filerStyle? filerStyle : "box-filter-film"}
                      masterlistType={masterlistType}
                      />
                    )
                  )}
            </HStack>
          </Stack>
          {/* {
        showSubscribeModal &&
        <SubscriptionModal setShowSubscribeModal={setShowSubscribeModal} />
      } */}
        </Container>
      </Stack>
    </>
  );
}
export default GridView;